import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "../../store/actions";
import mudeyLogoYellow from "~images/mudeyPurpleProYellow.svg"; // mudeyPurpleProYellow.svg | mudey_logo_yellow.svg
import { SidebarItem } from "./sidebarItem";
import { persistor } from "../../store";
import useUserRole from "../../hooks/useUserRole";
import "./index.less";
import ModernButton from "~components/modern-button";
import _ from 'lodash';
import { AddInsuranceIcon, CalendarIcon, ConfigurationsIcon, CrossIcon, DashboardIcon, MenuIcon, PaperIcon, PaperMoneyIcon, PersonIcon, ShieldWarningIcon, ExitIcon } from "../../utils/SVG";

const SideBar = () => {
  const dispatch = useDispatch();

  const [mobileMenu, setMobileMenu] = useState(false);

  const userData = useSelector((state: any) => state?.userData);

  const partnerNif = userData?.nif;
  const isPartnerVerified = userData?.verified == "VERIFIED";
  const partnershipType = userData?.partnershipType;
  const personPosition = userData?.personPosition;
  const { isViewer, isMember } = useUserRole();

  // Partners must finish the adhesion forms before they can use any feature.
  const isCotarDisabled = !isPartnerVerified || isViewer && personPosition !== "JAP_MANAGER";

  function handleLogout() {
    setMobileMenu(false);
    dispatch({ type: LOGOUT });
    persistor.purge();
  }

  function getDisabled(button) {
    return !isPartnerVerified
      || _.includes(button?.disabledFor, partnershipType)
      || isViewer && _.includes(button?.disabledFor, "VIEWER")
      || isMember && _.includes(button?.disabledFor, "MEMBER");
  }

  // blacklistedNifs               | Item won't show up at all in the sidebar
  // blacklistedPartnershipTypes   | Item won't show up at all in the sidebar (isViewer && isMember from useUserRole count into this list)
  // disabledFor                   | Item will show up, but will be disabled
  const navigationButtons = [
    {
      to: "/dashboard",
      icon: <DashboardIcon fill="var(--primary-color)" size="20" />,
      text: "Dashboard",

      blacklistedPartnershipTypes: ["JAP"],
      blacklistedNifs: ["503976555"]
    },
    {
      to: partnershipType === "JAP" ? "/clientes-jap" : "/clientes",
      icon: <PersonIcon fill="var(--primary-color)" size="20" />,
      text: "Clientes",

      blacklistedPartnershipTypes: ["PROMOTERS"],
    },
    {
      to: partnershipType === "JAP" ? "/simulações-jap" : "/simulações",
      icon: <CalendarIcon fill="var(--primary-color)" size="20" />,
      text: "Simulações",

      blacklistedPartnershipTypes: ["PROMOTERS"]
    },
    {
      to: "/seguros",
      icon: <PaperIcon fill="var(--primary-color)" size="20" />,
      text: "Apólices",

      blacklistedPartnershipTypes: ["PROMOTERS"],
      disabledFor: ["TECH"]
    },
    {
      to: "/sinistros",
      // its own icon: icon1u is the Apólices document
      icon: <ShieldWarningIcon fill="var(--primary-color)" size="20" />,
      text: "Sinistros",

      blacklistedPartnershipTypes: ["PROMOTERS", "JAP"],
      disabledFor: ["TECH"]
    },
    {
      to: "/recibos",
      icon: <PaperMoneyIcon fill="var(--primary-color)" size="20" />,
      text: "Recibos",

      blacklistedPartnershipTypes: ["PROMOTERS", "JAP"],
      disabledFor: ["TECH"]
    },
    {
      to: "/configuracoes",
      icon: <ConfigurationsIcon fill="var(--primary-color)" size="20" />,
      text: "Configurações",

      blacklistedPartnershipTypes: ["PROMOTERS"],
      disabledFor: ["MEMBER", "VIEWER"]
    }
  ];

  return (
    <div className={"navigation-tab " + (mobileMenu ? "open" : "")}>
      <div className="navigation-header">
        <img className="logo" src={mudeyLogoYellow}/>

        <button
          type="button"
          className="menu-trigger"
          aria-label="Menu"
          aria-expanded={mobileMenu}
          onClick={() => setMobileMenu(!mobileMenu)}
        >
          {mobileMenu
            ? <CrossIcon fill="var(--primary-color)" size="24" />
            : <MenuIcon fill="var(--primary-color)" size="24" />}
        </button>
      </div>

      <div className="navigation-content">
        <NavLink
          to="/cotar-seguros"
          onClick={isCotarDisabled ? (e) => e.preventDefault() : () => setMobileMenu(false)}
        >
          <ModernButton
            className="nav-button main-button"
            text="Cotar seguros"
            disabled={isCotarDisabled}
            icon={<AddInsuranceIcon fill="var(--primary-color)" size="20" />}
          />
        </NavLink>

        <hr/>

        <div className="navigation-buttons">
          {navigationButtons
            .filter(button => !_.includes(button?.blacklistedPartnershipTypes, partnershipType) && !_.includes(button?.blacklistedNifs, partnerNif))
            .map((button, index) => (
            <React.Fragment key={index}>
              {/* Add an <hr> on top of the Configurações button */}
              {button.text === "Configurações" ? <hr/> : undefined}

              <NavLink
                to={button?.to}
                className="nav-link"
                activeClassName="active"
                onClick={getDisabled(button) ? (e) => e.preventDefault() : () => setMobileMenu(false)}
              >
                <span className="active-indicator" />
                <ModernButton
                  className="nav-button other-button"
                  text={button?.text}
                  disabled={getDisabled(button)}
                  icon={button?.icon}
                />
              </NavLink>
            </React.Fragment>
          ))}
        </div>

        <div className="navigation-footer">
          <hr style={{ margin: '0' }} />

          <ModernButton
            className="nav-button leave-button"
            text="Sair"
            icon={<ExitIcon fill="var(--primary-color)" size="24" />}
            onClick={handleLogout}
          />
        </div>
      </div>

    </div>
  );
};

export default SideBar;
